module.exports = __webpack_public_path__ + "img/Screenshot-8.abd74963.png";